import { AnyAction, Reducer } from 'redux';
import { EffectsCommandMap } from 'dva';
import { addRooms, queryRooms, removeRooms, updateRooms, queryHosts } from './service';

import { BasicListItemDataType } from './data.d';

export interface StateType {
  list: BasicListItemDataType[];
}

export type Effect = (
  action: AnyAction,
  effects: EffectsCommandMap & { select: <T>(func: (state: StateType) => T) => T },
) => void;

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    fetch: Effect;
    appendFetch: Effect;
    submit: Effect;
  };
  reducers: {
    queryList: Reducer<StateType>;
    appendList: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'gameAndrooms',

  state: {
    list: [],
    hostList: [],
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const response = yield call(queryRooms, payload);
      const response2 = yield call(queryHosts, payload);
      yield put({
        type: 'queryList',
        payload: Array.isArray(response) ? response : [],
        payload2: Array.isArray(response2) ? response2 : [],
      });
    },
    *appendFetch({ payload }, { call, put }) {
      const response = yield call(queryRooms, payload);
      yield put({
        type: 'appendList',
        payload: Object.keys(response).length === 1 ? [] : response,
      });
    },
    *submit({ payload }, { call, put }) {
      let callback;
      if (payload.id) {
        callback = Object.keys(payload).length === 1 ? removeRooms : updateRooms;
      } else {
        callback = addRooms;
      }
      const response = yield call(callback, payload); // post
      yield put({
        type: 'queryList',
        payload: response,
      });
    },
  },

  reducers: {
    queryList(state, action) {
      const hostList = action.payload2 || state.hostList;
      return {
        ...state,
        hostList,
        list: action.payload,
      };
    },
    appendList(state = { list: [] }, action) {
      return {
        ...state,
        list: state.list.concat(action.payload),
      };
    },
  },
};

export default Model;
